import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { instance } from '../../axios/AxiosInstance';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordMatch, setNewPasswordMatch] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordMatch, setShowPasswordMatch] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const validatePassword = (password: string) => {
    return password.length > 6;
  };

  const validate = (): boolean => {
    if (!newPassword || !validatePassword(newPassword)) {
      setErrorMsg('Нууц үг хамгийн багадаа 7 тэмдэгт байх ёстой');
      return false;
    }

    if (newPassword !== newPasswordMatch) {
      setErrorMsg('Нууц үг таарахгүй байна');
      return false;
    }

    if (!searchParams.has('key')) {
      setErrorMsg('Холбоос буруу байна');
      return false;
    }

    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    setErrorMsg('');
    setLoading(true);

    instance
      .post('reset-password', {
        key: searchParams.get('key'),
        email: email,
        password: newPassword,
      })
      .then((res: { status: number; data?: { errorMsg?: string } }) => {
        if (res.status === 200) {
          setSuccessMsg('Нууц үг амжилттай шинэчлэгдлээ. Одоо нэвтрэх боломжтой.');
          setLoading(false);
        } else {
          setErrorMsg(res.data?.errorMsg || 'Алдаа гарлаа');
          setLoading(false);
        }
      })
      .catch((err: { response?: { data?: { message?: string } } }) => {
        console.error(err);
        setErrorMsg(err.response?.data?.message || 'Алдаа гарлаа');
        setLoading(false);
      });
  };

  return (
    <>
      <div className="login-form-heading">
        <h1 className="h1">Нууц үг шинэчлэх</h1>
        {!successMsg && (
          <p className="text-sub login-space-label">Шинэ нууц үгээ оруулна уу.</p>
        )}
      </div>

      <div className="login-form-container">
        {successMsg ? (
          <div className="login-form">
            <div className="form-alert form-alert--success">
              <span className="material-symbols-outlined">check_circle</span>
              <p className="text-sub">{successMsg}</p>
            </div>
            <Link
              to="/login"
              className="btn-primary login-space-btn"
              style={{ width: '100%', textAlign: 'center', textDecoration: 'none', display: 'block' }}
            >
              Нэвтрэх
            </Link>
          </div>
        ) : (
          <form action="#" className="login-form" onSubmit={handleSubmit}>
            {errorMsg && (
              <div className="form-alert form-alert--error" role="alert">
                <span className="material-symbols-outlined">warning</span>
                <p className="text-sm">{errorMsg}</p>
              </div>
            )}

            <label>
              <span className="label-text login-space-label">Имэйл</span>
              <input
                type="email"
                className="input login-space-input"
                placeholder="name@tomko.mn"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </label>

            <label>
              <span className="label-text login-space-label">Шинэ нууц үг</span>
              <div className="login-input-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="input login-space-input login-input-with-icon"
                  placeholder="Шинэ нууц үгээ оруулна уу"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="login-toggle-password"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Нууц үг нуух' : 'Нууц үг харуулах'}
                >
                  <span className="material-symbols-outlined" style={{ fontSize: 24 }}>
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </label>

            <label>
              <span className="label-text login-space-label">Нууц үг давтах</span>
              <div className="login-input-wrap">
                <input
                  type={showPasswordMatch ? 'text' : 'password'}
                  className="input login-space-input login-input-with-icon"
                  placeholder="Нууц үгээ дахин оруулна уу"
                  value={newPasswordMatch}
                  onChange={(e) => setNewPasswordMatch(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="login-toggle-password"
                  onClick={() => setShowPasswordMatch((v) => !v)}
                  aria-label={showPasswordMatch ? 'Нууц үг нуух' : 'Нууц үг харуулах'}
                >
                  <span className="material-symbols-outlined" style={{ fontSize: 24 }}>
                    {showPasswordMatch ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </label>

            <div className="login-submit-wrap">
              <button
                type="submit"
                className="btn-primary login-space-btn"
                style={{ width: '100%' }}
                disabled={loading}
              >
                {loading ? 'Хадгалж байна...' : 'Нууц үг шинэчлэх'}
              </button>
            </div>
          </form>
        )}
      </div>
    </>
  );
}
